webpackJsonp([230136554236071],{

/***/ 431:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Button = __webpack_require__(26);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(431);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var downloadBanner = _ref.downloadBanner;
	
	
	  if (!downloadBanner) return null;
	  var file = downloadBanner.file,
	      title = downloadBanner.title,
	      preview = downloadBanner.preview;
	
	
	  if (!file || !title || !preview) return null;
	  return _react2.default.createElement(
	    'div',
	    { className: 'section col6 downloadBanner' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container content DownloadBanner--Container' },
	      preview && file && _react2.default.createElement(
	        'a',
	        { className: 'DownloadBanner--Image', href: file.publicURL },
	        _react2.default.createElement('img', { className: 'hasShadow', src: preview.publicURL, alt: title })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'DownloadBanner--Content' },
	        _react2.default.createElement(
	          'h5',
	          null,
	          title
	        ),
	        file && _react2.default.createElement(
	          _Button2.default,
	          {
	            href: file.publicURL,
	            target: '_blank',
	            rel: 'noopener',
	            className: 'DownloadBanner--Button'
	          },
	          'Click Here'
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 700:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.DownloadPagesTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PageHeader = __webpack_require__(15);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(6);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _FamilyHandbookBanner = __webpack_require__(377);
	
	var _FamilyHandbookBanner2 = _interopRequireDefault(_FamilyHandbookBanner);
	
	__webpack_require__(700);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Export Template for use in CMS preview
	var DownloadPagesTemplate = exports.DownloadPagesTemplate = function DownloadPagesTemplate(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      downloadBanner = _ref.downloadBanner,
	      body = _ref.body,
	      meta = _ref.meta;
	
	
	  return _react2.default.createElement(
	    'main',
	    { className: 'DownloadPage background-dots' },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { defaultTitle: meta && meta.title || title + ' | Great Start ELC' },
	      meta && _react2.default.createElement('meta', { name: 'description', content: meta.description }),
	      meta && _react2.default.createElement('link', { rel: 'canonical', href: meta.canonical })
	    ),
	    _react2.default.createElement(_PageHeader2.default, { title: title, subtitle: subtitle }),
	    _react2.default.createElement(
	      'section',
	      { className: 'section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container content' },
	        _react2.default.createElement(_Content2.default, { source: body })
	      ),
	      _react2.default.createElement(_FamilyHandbookBanner2.default, { downloadBanner: downloadBanner })
	    )
	  );
	};
	
	var DownloadPages = function DownloadPages(_ref2) {
	  var page = _ref2.data.page;
	  return _react2.default.createElement(DownloadPagesTemplate, _extends({}, page, page.frontmatter, { body: page.html }));
	};
	
	exports.default = DownloadPages;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-download-pages-js-db1d1cdd17e56b7d5c90.js